"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashData = exports.preparePhoneNumberForHashing = void 0;
var crypto_js_1 = require("crypto-js");
var consts_1 = require("./consts");
var preparePhoneNumberForHashing = function (phoneNumber) {
    return phoneNumber.replace(consts_1.USER_REPLACEMENT_REGEX.phone, '');
};
exports.preparePhoneNumberForHashing = preparePhoneNumberForHashing;
var hashData = function (dataToHash) {
    var preparedDataToHash = dataToHash
        .toLowerCase()
        .replace(consts_1.USER_REPLACEMENT_REGEX.hash, '');
    return (0, crypto_js_1.SHA256)(preparedDataToHash).toString();
};
exports.hashData = hashData;
